export function useOverflowed() {
  const stopScroll = (e: Event) => {
    e.preventDefault()
  }

  const overflowHide = () => {
    document.body.classList.add('overflowed')
  }

  const overflowShow = () => {
    document.body.classList.remove('overflowed')
  }

  const stopScrollSubscribe = (element: HTMLElement) => {
    element?.addEventListener('touchmove', stopScroll, { capture: false, passive: false })
    document.documentElement.classList.add('overflowed')
    overflowHide()
  }

  const stopScrollUnsubscribe = (element: HTMLElement) => {
    element?.removeEventListener('touchmove', stopScroll, { capture: false })
    document.documentElement.classList.remove('overflowed')
    overflowShow()
  }

  return {
    stopScroll,
    overflowHide,
    overflowShow,
    stopScrollSubscribe,
    stopScrollUnsubscribe
  }
}
